import { render, staticRenderFns } from "./AffiliateDetails.vue?vue&type=template&id=17faa50e"
import script from "./AffiliateDetails.vue?vue&type=script&lang=ts"
export * from "./AffiliateDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports